import React from 'react';
export const useDebounce = (initial, delay = 300) => {
    const [value, set] = React.useState(initial);
    const [debounced, setDebounced] = React.useState(initial);
    React.useEffect(() => {
        const timer = window.setTimeout(() => setDebounced(value), delay);
        return () => window.clearTimeout(timer);
    }, [value, delay]);
    return { value, debounced, set };
};
export default useDebounce;
